import type { PageInfo } from "@newgenerated/shared/schema";

export const SECTION = "o_s";
export const ID = "o_i";
export const REFERENCE = "o_r";
export const POSITION = "o_p";

export function enhanceWithOriginPosition(params: URLSearchParams | null, pageInfo: PageInfo, index: number): URLSearchParams | undefined {
  if (params == null) {
    return undefined;
  }
  return new URLSearchParams(`${params}&${POSITION}=${pageInfo.page * pageInfo.pageSize + index}`);
}
